var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 21.9996C4.9344 21.9996 0 17.0652 0 10.9998C0 4.9344 4.9344 0 10.9998 0C12.7852 0 14.5571 0.437403 16.1257 1.26434C16.701 1.56855 16.9218 2.28113 16.6183 2.85736C16.3148 3.43359 15.6031 3.6542 15.0253 3.35003C13.7949 2.70043 12.4028 2.3577 10.9998 2.3577C6.23433 2.35753 2.35662 6.23415 2.35662 11C2.35662 15.7659 6.23325 19.6423 10.9989 19.6423C15.7644 19.6423 19.6421 15.7657 19.6421 11C19.6421 10.4553 19.5916 9.91069 19.4915 9.38338C19.3701 8.74418 19.7903 8.12692 20.4295 8.00553C21.0687 7.88343 21.6859 8.30499 21.8066 8.9435C21.9343 9.6158 21.9989 10.3071 21.9989 10.9993C21.9998 17.0656 17.0645 22 10.9995 22L10.9998 21.9996Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85493 15.3457H9.85423C9.5421 15.3457 9.24174 15.2204 9.02022 14.9996L5.70415 11.6731C5.24458 11.212 5.24616 10.4663 5.70644 10.006C6.16758 9.54644 6.91326 9.54729 7.37355 10.0083L9.85652 12.4992L20.0595 2.29932C20.5198 1.83903 21.2664 1.83903 21.7266 2.29932C22.1862 2.75961 22.1862 3.50614 21.7266 3.96571L10.689 15.0011C10.4675 15.221 10.1671 15.3456 9.85499 15.3456L9.85493 15.3457Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrant);
export default __webpack_public_path__ + "static/media/grant.09b23a684b7a8badea95cfa063afd680.svg";
export { ForwardRef as ReactComponent };